<div
  TsFieldStyling
  [fieldBackgroundColor]="fieldStyling().color"
  [fieldBold]="fieldStyling().is_bold"
  [targetStylingClass]="commonTargetStylingClass"
  class="flex-auto gt-xs:pr-3 w-full mb-2"
>
  <ts-datepicker
    [label]="fieldDef.label"
    [testId]="'form-field-' + fieldDef.name"
    [formControl]="date"
    [errorMessages]="dateErrorMessages"
    (dateChange)="onDateChange()"
    (blur)="dateBlur()"
  />
</div>
